import { useMutation, useQueryClient } from "@tanstack/react-query";
import { configuration } from "../../../configuration";
import { FetchError } from "../../types";
import { useAccessToken } from "../../use-access-token";
import { queryKeys } from "../queryKeys";

type Variables = {
  guid: string;
  assignedTeamSlug?: string;
};

const useDeleteMetricRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function deleteMetricRequest(variables: Variables) {
    const accessToken = await getAccessToken();

    const response = await fetch(`${configuration.apiRootUrl}/metrics/${variables.guid}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      method: "delete",
    });

    if (!response.ok) {
      throw new FetchError(response);
    }
  }

  return { deleteMetricRequest };
};

const useDeleteMetric = () => {
  const { deleteMetricRequest } = useDeleteMetricRequest();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteMetricRequest,
    onSuccess: async (_, variables) => {
      if (variables.assignedTeamSlug) {
        await queryClient.invalidateQueries({ queryKey: queryKeys.teams.getTeam(variables.assignedTeamSlug) });
      }

      await queryClient.invalidateQueries({ queryKey: queryKeys.metrics.getMetricCollections() });
    },
  });
};

export { useDeleteMetric };
